'use strict';

var _taggedTemplateLiteral = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  font-size: 16px;\n  line-height: 20px;\n  height: 40px;\n  &.ant-btn:not(.ant-btn-primary):not([disabled]) {\n    color: ", " !important;\n    border-color: ", ";\n\n\n    border-width: 2px;\n    border-radius: 6px;\n\n    &:hover {\n      opacity: 0.7;\n      color: ", " !important;\n      border-color: ", ";\n    }\n  }\n  &.ant-btn-primary {\n    background-color: ", ";\n    border-color: ", ";\n    border-radius: 6px;\n\n    &:hover {\n      background-color: ", " !important;\n      opacity: 0.7;\n    }\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      font-size: ", ";\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      &:hover {\n        color: ", ";\n      }\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      &:hover {\n        text-decoration: none;\n      }\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  color: ", ";\n  border: 0;\n  margin: 0;\n  padding: 0;\n  outline: 0;\n  background: none;\n  transition: color 0.3s, background 0.3s;\n  cursor: pointer;\n  &:hover {\n    color: ", ";\n    text-decoration: underline;\n  }\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      font-size: ", ";\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      border-radius: 4px;\n      color: white;\n      border-color: white;\n      background: transparent;\n      &:hover,\n      &:focus {\n        color: white;\n        background: rgba(255, 255, 255, 0.1);\n        border-color: white;\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      border-radius: 4px;\n      color: ", ";\n      border-color: ", ";\n      &:hover {\n        background: rgba(20, 150, 175, 0.05);\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  height: 32px;\n  min-width: 80px;\n  font-size: 14px;\n  border-radius: 4px;\n  padding: 8px 16px;\n  font-size: ", ";\n  line-height: 1.2;\n  font-weight: 400;\n  text-align: center;\n  touch-action: manipulation;\n  background: none;\n  border: 1px solid transparent;\n  white-space: nowrap;\n  transition: color 0.3s, background 0.3s ;\n  text-decoration: none;\n  cursor: pointer;\n\n  ", "\n\n  ", "\n  \n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _antd = require('antd');

var _polished = require('polished');

var _vars = require('./vars');

var _vars2 = _interopRequireDefault(_vars);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

var _index = require('./index');

var _isSp = require('../utils/isSp');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Btn = _styledComponents2.default.button(_templateObject(), _vars2.default.fontSizeBase, function (props) {
  return props.type === 'genTransp' && _styledComponents.css(_templateObject2(), _theme2.default.primary, _theme2.default.primary);
}, function (props) {
  return props.type === 'whiteTransp' && _styledComponents.css(_templateObject3());
}, function (props) {
  return props.fontSize === 'sm' && _styledComponents.css(_templateObject4(), _vars2.default.fontSizeSm);
});

Btn.defaultProps = {
  type: null,
  fontSize: null
};
var BtnLink = Btn.withComponent('a');

var BtnLikeLink = _styledComponents2.default.button(_templateObject5(), _theme2.default.primary, _index.colors.turquoise, function (props) {
  return props.withoutUnderline && _styledComponents.css(_templateObject6());
}, function (props) {
  return props.withoutHover && _styledComponents.css(_templateObject7(), _theme2.default.primary);
}, function (props) {
  return props.fontSize === 'sm' && _styledComponents.css(_templateObject8(), _vars2.default.fontSizeSm);
});

BtnLikeLink.defaultProps = {
  fontSize: null
};
var ThemedButton = (0, _styledComponents2.default)(_antd.Button)(_templateObject9(), function (props) {
  return (0, _polished.transparentize)(0.2, props.theme.platformPrimary);
}, function (props) {
  return (0, _isSp.isSp)() ? "white" : "#D3D4D9";
}, function (props) {
  return (0, _isSp.isSp)() ? "transparent" : _index.colors.navy.navy500;
}, function (props) {
  return (0, _polished.transparentize)(0.2, props.theme.platformPrimary);
}, function (props) {
  return (0, _polished.transparentize)(0.2, props.theme.platformPrimary);
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return (0, _polished.transparentize)(0.2, props.theme.platformPrimary);
});
exports.default = {
  Btn: Btn,
  BtnLink: BtnLink,
  BtnLikeLink: BtnLikeLink,
  ThemedButton: ThemedButton
};